module.exports = __webpack_public_path__ + "img/03.5569546f.png";